import { render, staticRenderFns } from "./SettingPinFormConfirmation.vue?vue&type=template&id=167bce93"
import script from "./SettingPinFormConfirmation.vue?vue&type=script&lang=js"
export * from "./SettingPinFormConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SettingPinFormConfirmation.vue?vue&type=style&index=0&id=167bce93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports